import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AppFacadeService } from '../../../services/app-facade.service';
import { DialogContentType } from '../../../enums/dialog-type.enum';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'por-request-sent-successfully-dialog',
    standalone: true,
    imports: [CommonModule, TranslateModule, SharedModule],
    templateUrl: './request-sent-successfully-dialog.component.html',
    styleUrls: ['./request-sent-successfully-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestSentSuccessfullyDialogComponent {
    readonly appFacadeService = inject(AppFacadeService);

    dialogContentType = DialogContentType;
    message = '';
}
